import { useState, useCallback } from 'react';

import { SocialMediaType } from '@/helpers/enumsTypes';

const defaultFields = {
  firstname: '',
  lastname: '',
  email: '',
  socialMediaId: '',
  dob: '',
  type: SocialMediaType.Empty,
  picture: '',
  password: '',
  keepLoggedIn: false,
};

export const useSocialSignupForm = () => {
  const [formFieldsState, setFormFieldsState] = useState(defaultFields);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  // Update form state - used for initial data from social login
  const updateFormState = useCallback((updates: Partial<typeof defaultFields>) => {
    setFormFieldsState((prev) => ({ ...prev, ...updates }));
  }, []);

  const resetForm = useCallback(() => {
    setFormFieldsState(defaultFields);
    setIsSubmitDisabled(true);
  }, []);

  return {
    formFieldsState,
    setFormFieldsState,
    isSubmitDisabled,
    setIsSubmitDisabled,
    updateFormState,
    resetForm,
  };
};
